import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';

class FooterSection extends Component {

    render(){
        return (
                <div className="single-footer-widget">
                    <FormattedMessage id='footer_sec_partner_title'
                                          tagName={"h6"}
                    />
                    <ul className="footer-nav">
                        <li><a href="http://www.uad360.com/" target="_blank"><FormattedMessage id='footer_sec_partner_1'
                        /></a></li>
                    </ul>
                </div>
        );
    }
}

export default FooterSection;


// WEBPACK FOOTER //
// ./src/components/FooterSection.js